import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import cookie from 'js-cookie'


const decorator = (storeProps) => (ComposedComponent) =>

  class WrappedComponent extends PureComponent {

    static WrappedComponent = ComposedComponent

    static displayName = `injectGlobals(${ComposedComponent.displayName || ComposedComponent.name})`

    static contextTypes = {
      globals: PropTypes.object.isRequired,
    }

    data = {}

    componentWillMount() {
      const { globals, globals: { setRedirectLink } = {} } = this.context

      const props = {
        globals,
        setRedirectLink,
        getAbValue: this.getAbValue,
        getCookieValue: this.getCookieValue,
        getFeatureToggle: this.getFeatureToggle,
        redirect: this.redirect,
      }

      if (typeof storeProps === 'function') {
        this.data = storeProps(props, this.props)
      }
      else {
        Object.keys(storeProps).forEach((key) => {
          this.data[key] = storeProps[key](props, this.props)
        })
      }
    }

    redirect = (link) => {
      const { globals: { setRedirectLink } } = this.context

      if (setRedirectLink) {
        setRedirectLink(link)
      }
      else {
        actions.models.router.replace(link)
      }
    }

    getAbValue = (name) => {
      const { globals: { abTests } } = this.context
      const ab = abTests[name]

      if (!ab || !ab.value) {
        return 'a'
      }

      return ab.value
    }

    getCookieValue = (name) => {
      if (process.env.WEBPACK === 'build.server') {
        const { globals: { cookies } } = this.context

        let cookieValue

        try {
          cookieValue = JSON.parse(cookies[name])
        }
        catch (err) {
          cookieValue = cookies[name]
        }

        return cookieValue
      }

      return cookie.getJSON(name)
    }

    getFeatureToggle = (name) => {
      const { globals: { features } } = this.context

      return features[name]
    }

    render() {

      return (
        <ComposedComponent
          {...this.props}
          {...this.data}
        />
      )
    }
  }


export default decorator
